/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Token_Shown_DescriptionInputs */



/**
* | output |
* | --- |
* | "This token will not be shown again. Configure it in your oneai-agent deployment as the bearer token." |
*
* @param {Agents_Token_Shown_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_token_shown_description = /** @type {((inputs?: Agents_Token_Shown_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Token_Shown_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Schlüssel wird nicht erneut angezeigt. Verwenden Sie ihn als Bearer-Token in Ihrer oneai-agent-Konfiguration.")
	return /** @type {LocalizedString} */ ("This token will not be shown again. Configure it in your oneai-agent deployment as the bearer token.")
});